<template>
  <div>
    <modal v-if="reveal" xsmall @close="reveal = false" class="reveal">
      <div slot="body">
        <div class="p-5 text-center">
          <h2>{{ $t('airportparking.results.product.reveal_discount') }}</h2>
          <h4>{{ $t('airportparking.results.product.reveal_join') }}</h4>
          <div class="input-group mt-4">
            <input 
              type="email" 
              class="form-control"
              :class="{ 'border-danger' : emailError }"
              v-model="email"
              :placeholder="$t('airportparking.results.product.email_address')" 
              :aria-label="$t('airportparking.results.product.email_address')"
            />
            <div class="input-group-append">
              <button class="btn btn-secondary" @click="revealDiscount" type="button">{{ $t('airportparking.results.product.activate') }}</button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { sync, call, get } from "vuex-pathify";
import mixins from "@/mixins";
import { Modal } from "@/components";

export default {
  name: "timeout",
  mixins: [mixins.load, mixins.validate],
  components: { Modal },
  data() {
    return {
      email: '',
      emailError: false
    }
  },
  computed: {
    ...sync('quote/*'),
    reveal: sync('modals/reveal'),
    airport: get('results/airport@airport_name')

  },
  methods: {
    load: call('results/getResults'),
    sendEmail: call('results/revealPromo'),
    revealDiscount() {
      if(this.validEmail(this.email)) {
        this.sendEmail({ email: this.email, airport: this.airport }).then(() => {
          this.emailError = false;
          this.rhp = true;
          this.reveal = false;
          this.stevefetti(5000).then(() => {
            this.load();
          })
        })

      } else {
        this.emailError = true;
      }
    }
  }
};
</script>